import { AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-browser';
import { getMsalInstance } from '@/Infrastructure/Security/msalInstance';

const POWER_BI_SCOPES = ['https://analysis.windows.net/powerbi/api/Report.Read.All'];

/**
 * Acquires a Power BI access token. MSAL owns the cache: this returns the stored token until it is close to expiry and
 * renews it silently after that, so callers should call this every time rather than holding on to a token themselves.
 */
export async function acquirePowerBiToken(): Promise<AuthenticationResult> {
  const msalInstance = getMsalInstance();
  const account = msalInstance.getActiveAccount();

  if (!account) {
    throw new Error('No active account is available to acquire a Power BI token.');
  }

  const request = { scopes: POWER_BI_SCOPES, account };

  try {
    return await msalInstance.acquireTokenSilent(request);
  } catch (err) {
    if (!(err instanceof InteractionRequiredAuthError)) {
      throw err;
    }
    // First use needs consent for the Power BI scope, which cannot happen silently
    return await msalInstance.acquireTokenPopup(request);
  }
}
